import webBackApi from '../../api/webBackApi';

export const getVideoBatchRuns = async () => {
  try {
    const response = await webBackApi.get('/api/logs/video-batch/runs');
    return response.data;
  } catch (error) {
    console.error("Error fetching video batch runs:", error);
    throw error;
  }
};

export const getVideoBatchRunDetail = async (runId) => {
  try {
    const response = await webBackApi.get(`/api/logs/video-batch/runs/${runId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching video batch run detail:", error);
    throw error;
  }
};

export const getVideoBatchRunFailures = async (runId) => {
  try {
    const response = await webBackApi.get(`/api/logs/video-batch/runs/${runId}/failures`);
    return response.data;
  } catch (error) {
    console.error("Error fetching video batch run failures:", error);
    throw error;
  }
};
